import { Reducer } from 'redux';

interface State {
    token: string,
    logado: boolean,
    tenantId: string,
    expirado: boolean,
    administrador: boolean,
    usarSidebarLayout: boolean,
}

const INITIAL_STATE: State = {
    token: '',
    tenantId: '',
    logado: false,
    expirado: false,
    administrador: false,
    usarSidebarLayout: false,
};

const reducer: Reducer<State> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'LOG_IN':
            return { ...state, token: action.token, logado: true, expirado: false, usarSidebarLayout: action.usarSidebarLayout, }
        case 'LOG_OUT':
            return { ...state, token: '', logado: false, expirado: false, usarSidebarLayout: false, }
        case 'LOG_OUT_EXPIRED':
            return { ...state, token: '', logado: false, expirado: true, usarSidebarLayout: false, }
        default:
            return state;
    }
}

export default reducer;